import React from "react";
import { getDisabledStateFromLifecycleStatuses } from "../../utilities/lifecycleStatus";
import {
	IconArchive,
	IconArchiveOff,
	IconCursorText,
	IconTrashOff,
	IconTrashX,
} from "@tabler/icons-react";
const FolderContextMenu = ({ folder, permissions, callbacks }) => {
	const { folderLifecycleStatus } = folder;
	const { matterOrFolderLifecycleStatusObject, archiveAccess } = permissions;
	const { onRename, onDelete, onRestore, onArchive, onUnarchive } = callbacks;

	const folderLifecycleStatusObject = getDisabledStateFromLifecycleStatuses({
		folderLifecycleStatus,
	});

	const folderArchiveAccess = archiveAccess
		? folderLifecycleStatusObject.IN_ARCHIVE
			? archiveAccess.unarchive
			: archiveAccess.archive
		: null;

	const trashFromArchiveBlocked =
		!!folderLifecycleStatusObject.IN_ARCHIVE &&
		!!folderArchiveAccess?.disabled;

	return [
		{
			text: "Rename",
			onSelect: onRename,
			iconComponent: (
				<IconCursorText size={16} style={{ verticalAlign: "sub" }} />
			),
		},
		{ sectionHeader: true, text: "Archive + Trash" },
		onArchive || onUnarchive
			? folderLifecycleStatusObject.IN_ARCHIVE
				? {
						text: "Unarchive Folder",
						disabled:
							matterOrFolderLifecycleStatusObject.disabled ||
							folderArchiveAccess.disabled,
						disabledHoverText:
							matterOrFolderLifecycleStatusObject.disabled
								? matterOrFolderLifecycleStatusObject.disabledText
								: folderArchiveAccess.disabled
									? folderArchiveAccess.disabledText
									: "",
						onSelect: onUnarchive,
						iconComponent: (
							<IconArchiveOff
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						),
					}
				: {
						text: "Archive Folder",
						disabled:
							matterOrFolderLifecycleStatusObject.disabled ||
							folderArchiveAccess.disabled,
						disabledHoverText:
							matterOrFolderLifecycleStatusObject.disabled
								? matterOrFolderLifecycleStatusObject.disabledText
								: folderArchiveAccess.disabled
									? folderArchiveAccess.disabledText
									: "",
						onSelect: onArchive,
						iconComponent: (
							<IconArchive
								size={16}
								style={{ verticalAlign: "sub" }}
							/>
						),
					}
			: null,
		folderLifecycleStatusObject.IN_TRASH
			? {
					text: "Restore Folder from Trash Bin",
					disabled: matterOrFolderLifecycleStatusObject.disabled,
					disabledHoverText:
						matterOrFolderLifecycleStatusObject.disabled
							? matterOrFolderLifecycleStatusObject.disabledText
							: "",
					onSelect: onRestore,
					iconComponent: (
						<IconTrashOff
							size={16}
							style={{ verticalAlign: "sub" }}
						/>
					),
				}
			: {
					text: "Move Folder to Trash Bin",
					disabled:
						matterOrFolderLifecycleStatusObject.disabled ||
						trashFromArchiveBlocked,
					disabledHoverText:
						matterOrFolderLifecycleStatusObject.disabled
							? matterOrFolderLifecycleStatusObject.disabledText
							: trashFromArchiveBlocked
								? folderArchiveAccess.disabledText
								: "",
					onSelect: onDelete,
					iconComponent: (
						<IconTrashX
							size={16}
							style={{ verticalAlign: "sub" }}
						/>
					),
				},
	].filter(Boolean);
};

export default FolderContextMenu;
